module.exports = __webpack_public_path__ + "static/aesthetik-logo-02-81105eb72dd47e55695ec94654ddb7e0.jpg";